var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSafetyCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M31.5 23.909c0 .773-.685 1.591-1.523 1.591H10.034c-.84 0-1.534-.818-1.534-1.591V12.104c0-.773.695-1.249 1.534-1.249h19.943c.838 0 1.523.449 1.523 1.223zM31.5 13.677h-23M31.5 16.677h-23"
}))));
export default SvgSafetyCard;